// import { createSelector } from 'reselect';

export const getCategory = state => state.getIn(['news', 'category']);
export const getActivities = state => state.getIn(['news', 'activities']);
export const getNews = state => state.getIn(['news', 'news']);
export const getMedias = state => state.getIn(['news', 'medias']);
export const getCurrentMedia = state => state.getIn(['news', 'currentMedia']);
export const getCurrentNews = state => state.getIn(['news', 'currentNews']);
